export { default as SapCollateralChangeSlot } from './SapCollateralChangeSlot';
